module.exports = __webpack_public_path__ + "img/fuwu2.42e5d8a7.jpg";